import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { WhyUs } from "@/components/WhyUs";
import { Courses } from "@/components/Courses";
import { HowItWorks } from "@/components/HowItWorks";
import { PreEnroll } from "@/components/PreEnroll";
import { Locations } from "@/components/Locations";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";
import { VideoReel } from "@/components/VideoReel";

export default function Landing() {
  return (
    <div className="min-h-screen bg-ink-900 text-white selection:bg-gold-500">
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#151522",
            border: "1px solid rgba(229,193,88,0.3)",
            color: "#F8F8F5",
          },
        }}
      />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <WhyUs />
        <VideoReel />
        <Courses />
        <HowItWorks />
        <PreEnroll />
        <Locations />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
